export const dealersSchema = {
	schema: {
		title: 'dealers schema',
		description: 'Dealers Schema',
		version: 0,
		primaryKey: 'sfid',
		type: 'object',
		properties: {
			id: {
				type: 'number',
			},
			sfid: {
				type: 'string',
				maxLength: 250,
			},
			hierarchylevel1wssterritory_c: {
				type: 'string',
			},
			dealercode_c: {
				type: 'string',
			},
			dealername_c: {
				type: 'string',
			},
		},
		required: ['id', 'sfid', 'hierarchylevel1wssterritory_c', 'dealercode_c', 'dealername_c'],
	},
};
